export default "__VITE_ASSET__CMBcmcpD__"